export default {
  methods: {
    handleError(error, {
      toast,
      fallback = "",
    } = {}) {
      console.error('Error', error);
      const showToast = toast ?? true;

      if (showToast) this.$toast.error(
        this.getErrorMessage(error, fallback)
      );
    },

    getErrorMessage(error, fallback = "") {
      return error?.response?.data?.detail?.[0]?.msg
        || error?.response?.data?.detail
        || error?.response?.data?.status_message
        || error?.message
        || fallback
        || this.$t("general.default_error");
    },
  },
}
